// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"327":"1c1ed9144d9e8ba23e95","500":"dda3d381f5617948ce42"}[chunkId] + ".js";
};